import React from "react";
import { Button } from "@abb/abb-common-ux-react";
import { Translation } from "react-i18next";

interface IProps {
    id?: string
    list?: any[]
}

export default class PositionBar extends React.Component<IProps> {

    id = this.props.id ? this.props.id : "testplan-content"
    private onLeft() {
        this.scrollLeft(document.getElementById(this.id), -300, 1000);
    }

    private onRight() {
        this.scrollLeft(document.getElementById(this.id), 300, 1000);
    }

    private scrollLeft(element: any, change: any, duration: any) {
        const start = element.scrollLeft;
        let currentTime = 0;
        const increment = 20;
        const easeInOutQuad = (t: any, b: any, c: any, d: any) => {
            t /= d / 2;
            if (t < 1) {
                return (c / 2) * t * t + b;
            }
            t--;
            return (-c / 2) * (t * (t - 2) - 1) + b;
        };
        const animateScroll = () => {
            currentTime += increment;
            const val = easeInOutQuad(currentTime, start, change, duration);
            element.scrollLeft = val;
            if (currentTime < duration) {
                setTimeout(animateScroll, increment);
            }
        };
        animateScroll();
    }

    public render() {
        return (
            <Translation>
                {
                    t =>
                        <div className={this.props.id ? "row centered centered-landing-margin" : "row centered centered-form-margin"}>
                            <div className="left-icon" style={{ width: "3%", marginTop: "12px" }}>
                                <div className="icon-background-scroll cursor">
                                    <Button type="discreet-black"
                                        onClick={() => this.onLeft()}
                                        disabled={this.props.list.length > 5 ? false:true}
                                        shape="rounded"
                                        icon="abb/left" />
                                </div>
                            </div>

                            <div className={this.props.id ? "center-content-testplan center-content-testplan-margin" : "center-content-testplan ml-2"} id={this.id}>
                                <div className="stepwizard">
                                    <div className="stepwizard-row setup-panel">
                                        <a href="#step-1" className="sideposition-bar" />
                                        {this.props.children}
                                        <a href="#step-1" className="sideposition-bar margin-bar" />
                                    </div>
                                </div>
                            </div>

                            <div className="right-icon right-icon-test" style={{marginTop: "12px"}}>
                                <div className="icon-background-scroll">
                                    <Button type="discreet-black" 
                                    shape="rounded" 
                                    disabled={this.props.list.length > 5 ? false:true}
                                    icon="abb/right" onClick={() => this.onRight()} />
                                </div>
                            </div>
                            <div className="clearfix" />
                        </div>
                }
            </Translation>
        )
    }
}